'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardVideo = require('../ContentCardVideo');

var _ContentCardVideo2 = _interopRequireDefault(_ContentCardVideo);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

var _TwitterDetails = require('../TwitterDetails/TwitterDetails');

var _TwitterDetails2 = _interopRequireDefault(_TwitterDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwitterVideoContentCard = function (_React$Component) {
  _inherits(TwitterVideoContentCard, _React$Component);

  function TwitterVideoContentCard(props) {
    _classCallCheck(this, TwitterVideoContentCard);

    var _this = _possibleConstructorReturn(this, (TwitterVideoContentCard.__proto__ || Object.getPrototypeOf(TwitterVideoContentCard)).call(this, props));

    _this.state = {
      videoPlaying: false
    };

    _this.onVideoPlayed = _this.onVideoPlayed.bind(_this);
    _this.onVideoStopped = _this.onVideoStopped.bind(_this);
    return _this;
  }

  _createClass(TwitterVideoContentCard, [{
    key: 'onVideoPlayed',
    value: function onVideoPlayed() {
      this.setState({
        videoPlaying: true
      });
    }
  }, {
    key: 'onVideoStopped',
    value: function onVideoStopped() {
      this.setState({
        videoPlaying: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ContentCardVideo2.default, {
          onPlayCallback: this.onVideoPlayed,
          onStopCallback: this.onVideoStopped,
          poster: this.props.posterURL,
          src: this.props.videoURL,
          trackEvent: this.props.trackEvent,
          type: 'twitter',
          modalEnabled: this.props.modalEnabled,
          url: this.props.url,
          viewOnExternalSite: this.props.viewOnExternalSite
        }),
        !this.state.videoPlaying && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_ContentCardHeader2.default, { isLarge: this.props.isLarge, iconType: 'twitter' }),
          _react2.default.createElement(_TwitterDetails2.default, {
            isLarge: this.props.isLarge,
            authorHandle: this.props.authorHandle,
            authorName: this.props.authorName,
            url: this.props.url,
            verified: this.props.verified,
            profileUrl: this.props.profileUrl,
            profileImageUrl: this.props.profileImageUrl
          })
        ),
        _react2.default.createElement(_ContentCardText2.default, {
          videoPlaying: this.state.videoPlaying,
          caption: this.props.caption,
          text: this.props.text,
          isLarge: this.props.isLarge
        }),
        this.props.messengerShareButton
      );
    }
  }]);

  return TwitterVideoContentCard;
}(_react2.default.Component);

TwitterVideoContentCard.propTypes = {
  authorHandle: _propTypes2.default.string.isRequired,
  authorName: _propTypes2.default.string.isRequired,
  messengerShareButton: _propTypes2.default.node,
  posterURL: _propTypes2.default.string.isRequired,
  profileUrl: _propTypes2.default.string.isRequired,
  profileImageUrl: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired,
  verified: _propTypes2.default.bool.isRequired,
  videoURL: _propTypes2.default.string.isRequired,
  trackEvent: _propTypes2.default.func,
  caption: _propTypes2.default.string,
  modalEnabled: _propTypes2.default.bool,
  viewOnExternalSite: _propTypes2.default.bool,
  isLarge: _propTypes2.default.bool
};

TwitterVideoContentCard.defaultProps = {
  messengerShareButton: null,
  trackEvent: null,
  caption: '',
  modalEnabled: false,
  isLarge: false,
  viewOnExternalSite: false
};

TwitterVideoContentCard.displayName = 'TwitterVideoContentCard';

exports.default = (0, _withContentCardFooter2.default)(TwitterVideoContentCard);